<template>
  <div>
    <a target="_blank" rel="noopener noreferrer" href="https://consultas.neuland.com.py/servlet/ahrconslogin">
      <div class="text-primary flex items-center mb-8" >
        <Link class="fill-current shadow p-1 rounded bg-background w-5 h-5 mr-1" />
        <h5 class="heading uppercase tracking-tight" >versión detallado</h5>
      </div>
    </a>
    <section class="flex flex-col justify-center items-center">
      <div>
        <Logo class="logo"/>
      </div>
      <form id="login" @submit="checkForm">
        <transition name="fade" class="form-wrapper-sm">
          <p class="mx-4" v-if="errors && errors.length">
            <b>Algo salió mal con su inicio de sesión. Inténtalo de nuevo.</b>
          </p>
        </transition>
        <div class="form-wrapper">
          <input
            v-model="username"
            type="tel"
            minlength="4"
            maxlength="6"
            pattern="\d*"
            id="user"
            class="input"
            placeholder="Nro. de Cuenta"
          >
          <input
            v-model="password"
            id="password"
            type="password"
            pattern="\d*"
            class="input"
            placeholder="Nro. de PIN"
          >
        </div>
        <div class="form-wrapper-sm">
          <button type="submit" class="btn">Iniciar Sesión</button>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import Logo from "@/icons/logo.svg";
import Link from "@/icons/link.svg";
export default {
  name: "login",
  components: {
    Logo,
    Link
  },
  data() {
    return {
      username: null,
      password: null,
      errors: [],
      clicked: false
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.app.loggedIn;
    },
    failed() {
      return this.$store.state.app.loginFailed;
    }
  },
  methods: {
    checkForm: function(e) {
      this.$store.dispatch("reset_login");
      this.clicked = true;
      e.preventDefault();

      if (this.username && this.password) {
        this.submitForm();
        return true;
      }

      this.errors = [];

      if (!this.name) {
        this.errors.push("Account number required.");
      }
      if (!this.age) {
        this.errors.push("Password required.");
      }
    },
    submitForm: function() {
      this.$store.dispatch({
        type: "login",
        user: { username: this.username, password: this.password }
      });
    }
  },
  filters: {
    obfuscate: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  activated() {
    this.clicked = false;
    if (this.$store.state.app.forcedLogout == false)
      this.$store.dispatch("test_login");
  },
  mounted() {
    if (this.$store.state.app.forcedLogout == false)
      this.$store.dispatch("test_login");
  },
  watch: {
    loggedIn() {
      if (this.loggedIn == true) {
        console.log("Logged In");
        this.$router.push(this.$store.state.app.defaultAccount + "/0");
      }
    },
    failed() {
      if (this.failed == true && this.clicked == true) {
        this.errors.push("Login failed");
      }
    }
  }
};
</script>

<style>
.cls-1 {
  fill: #002776;
}
.cls-2 {
  fill: #a3bd31;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

